import { render, staticRenderFns } from "./PayRecodePage.vue?vue&type=template&id=2328c9c7&scoped=true"
import script from "./PayRecodePage.vue?vue&type=script&lang=js"
export * from "./PayRecodePage.vue?vue&type=script&lang=js"
import style0 from "./PayRecodePage.vue?vue&type=style&index=0&id=2328c9c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2328c9c7",
  null
  
)

export default component.exports